import { useEffect, useState } from 'react';

export function useScreenSize() {
  const [size, setSize] = useState({ width: -1, height: -1 });
  useEffect(() => {
    const listener = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };

    listener();
    window.addEventListener('resize', listener);

    return () => window.removeEventListener('resize', listener);
  }, []);

  return size;
}

export function useBreakpoint() {
  const size = useScreenSize();
  if (size.width < 640) {
    return 'xs';
  } else if (size.width < 768) {
    return 'sm';
  } else if (size.width < 1024) {
    return 'md';
  } else if (size.width < 1280) {
    return 'lg';
  } else if (size.width < 1536) {
    return 'xl';
  } else {
    return '2xl';
  }
}

export function useModalSize(): ModalSize {
  const breakpoint = useBreakpoint();
  const enableFull = false;

  if (breakpoint === 'xs' && enableFull) {
    return 'full';
  }

  return undefined;
}

export type ModalSize =
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | '2xl'
  | 'full'
  | 'xs'
  | '3xl'
  | '4xl'
  | '5xl'
  | undefined;
